import { render, staticRenderFns } from "./Clientele.vue?vue&type=template&id=151ae77c&"
import script from "./Clientele.vue?vue&type=script&lang=ts&"
export * from "./Clientele.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports